<template>
  <div class="wrapper">

    <side-bar type="sidebar" :sidebar-links="$sidebar.sidebarLinks">
<!--      <form class="navbar-form navbar-left navbar-search-form navbar-search-form-mobile" role="search">-->
<!--        <div class="input-group">-->
<!--          <span class="input-group-addon"><i class="fa fa-search"></i></span>-->
<!--          <input type="text" value="" class="form-control" placeholder="Search...">-->
<!--        </div>-->
<!--      </form>-->
      <mobile-menu></mobile-menu>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import UserMenu from 'src/components/UIComponents/SidebarPlugin/UserMenu.vue'
  import MobileMenu from 'src/components/UIComponents/SidebarPlugin/MobileMenu.vue'
  import axios from 'axios'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
      MobileMenu
    },
    data () {
      return {
        fieldsToTranslate: [
          'Next', 'Back', 'I Agree and Submit', 'Patient Results Retrieval', 'Patient Registration Form',
          'Please input the Location Code provided to you', 'Site', 'Medical Data', 'Disclaimer', 'Send Method',
          'Validation', 'Results', 'First Name', 'Last name', 'Date Of Birth', 'Address', 'Confirmation Number',
          'Please tell us about yourself', 'I agree', 'How would you like to receive your security code',
          'A security code was sent to', 'Please input the code provided to you', 'Register', 'here',
          'Insurance Information', 'Submission', 'Check your results', 'Email', 'Gender', 'Race', 'Ethnicity',
          'Phone', 'Please answer to the best of your knowledge', 'Please provide insurance information',
          'Select payment Type', 'Insurance', 'Cash', 'Primary Insurance Name', 'Policy Number', 'Group Number',
          'Subscriber Name', 'Relationship to Patient', 'Telehealth Appointment Setup', 'Result',
          'Choose Time Period', 'Morning', 'Afternoon', 'Any', 'Please tell us more about yourself', 'Confirmation Email',
          'Insured First Name', 'Insured Last Name', 'Insured Date of Birth', 'Insured Gender', 'Insurance Card',
          'Driver License', 'Office/Employer Code', 'Self', 'Child', 'Parent', 'Spouse', 'Note', 'Uninsured', 'Consent',
          'Social Security Number', 'Driver License Number', 'If your insurance is not available in the list please select Other',
          'Address is the same as previously entered', 'Insured Address', 'Insured Address 2', 'Client Bill'
        ]
      }
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      translateFieldsES () {
        let translate = this.fieldsToTranslate
        let params = { translate }

        axios({
          url: process.env.SERVER_URI + '/translation/spanish',
          method: 'post',
          data: params
        })
        .then((response) => {
          this.$store.state.translation_es = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      translateFieldsZH () {
        let translate = this.fieldsToTranslate
        let params = { translate }

        axios({
          url: process.env.SERVER_URI + '/translation/chinese',
          method: 'post',
          data: params
        })
        .then((response) => {
          this.$store.state.translation_zh = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    },
    async beforeMount () {
      await this.translateFieldsES()
      await this.translateFieldsZH()
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue